import { j as jsxRuntimeExports } from './../../../../../ext/react/jsx-runtime.js';
import { Base } from '../../../Internal/Base/Base.js';

const pathStrings = {
    16: [
        'M12.802 14.4A8 8 0 103.197 1.603a8 8 0 009.605 12.796zm-1.809-1.2c-.88.51-1.903.8-2.993.8-1.09 0-2.112-.29-2.993-.799a2.982 2.982 0 01.498-1.867A5.025 5.025 0 014 10a4.99 4.99 0 00-.801 1.6A6 6 0 1114 8c0 1.35-.446 2.597-1.199 3.6a5.012 5.012 0 00-2.306-2.934A3 3 0 108 10a3 3 0 012.993 3.201zM9 7a1 1 0 11-2 0 1 1 0 012 0z',
    ],
    24: [
        'M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm-4.5 9.5a4.5 4.5 0 117.628 3.235A7.02 7.02 0 0118.71 18 8.968 8.968 0 0021 12a9 9 0 10-15.709 6 6.976 6.976 0 011.772-2.962l.232-.221 1.345 1.48A4.982 4.982 0 007.025 19.5 8.944 8.944 0 0012 21c1.84 0 3.55-.552 4.975-1.5a5 5 0 00-4.748-4.495L12 15a4.5 4.5 0 01-4.5-4.5zM12 8a2.5 2.5 0 100 5 2.5 2.5 0 000-5z',
    ],
};
const IconProfile = ({ size, className, ...rest }) => {
    const paths = pathStrings[size].map((d, i) => (jsxRuntimeExports.jsx("path", { d: d, fillRule: "evenodd" }, String(i))));
    return (jsxRuntimeExports.jsx(Base, { as: "svg", height: size, width: size, viewBox: `0 0 ${size} ${size}`, className: className, xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", preserveAspectRatio: "xMidYMid meet", fill: "currentColor", ...rest, children: paths }));
};
IconProfile.displayName = 'IconProfile';

export { IconProfile };
//# sourceMappingURL=IconProfile.js.map
